import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { cn } from '../utils/cn';
import { PageTitle } from './PageTitle';

// =============================================================================
// Breadcrumb / PageHeader — 뎁스 표기 공용 포맷 (Figma).
//   1Depth (좌측 LNB만) 또는 1Depth > 2Depth > 3Depth (상세 진입).
//   마지막 항목은 진하게(현재 위치), 앞 항목은 딤 + 클릭 시 해당 뎁스로 이동.
// =============================================================================

export type Crumb = { label: string; to?: string };

export function Breadcrumb({ items, className }: { items: Crumb[]; className?: string }): JSX.Element {
  return (
    <nav aria-label="breadcrumb" className={cn('text-[12px] text-text-dim', className)}>
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <span key={`${c.label}-${i}`}>
            {i > 0 && <span className="mx-1 text-text-faint">&gt;</span>}
            {last ? (
              <span className="font-semibold text-text">{c.label}</span>
            ) : c.to ? (
              <Link to={c.to} className="hover:text-text">{c.label}</Link>
            ) : (
              <span>{c.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}

/**
 * 페이지 제목 — 마지막 뎁스명만 PageTitle 규격으로 그린다. 브레드크럼(작은 글씨)은
 * 2026-09-14 결정으로 모든 메뉴에서 제거했다. 새 코드는 PageTitle을 직접 쓴다.
 */
export function PageHeader({
  items,
  title,
  className,
  actions,
}: {
  items: Crumb[];
  title?: string;
  className?: string;
  actions?: ReactNode;
}): JSX.Element {
  const last = items[items.length - 1];
  return <PageTitle title={title ?? last?.label ?? ''} className={className} actions={actions} />;
}
